// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1728":"7ed31f643f2bbadd","4546":"49718799e90fec31","7296":"7639a1598cb1e058","7675":"43606d82205b3ec8","8560":"a465c37c899d5b06"}[chunkId] + ".css";
};